import React, { useState } from "react";
import classNames from "classnames";

import styles from "./EntryCardLarge.module.css";
import { Tag } from "../Tag";
import { LikeButton } from "../LikeButton";
import { LikeButtonLarge } from "../LikeButtonLarge";
import Icon from "../Icon";

type Props = {
  title?: string;
  userName?: string;
  description?: string;
  imageUrl?: string;
  category?: string;
  likes?: number;
  hasLiked?: boolean;
  onLike: () => void;
  onUnlike: () => void;
  onClose: () => void;
};

const EntryCardLarge: React.FC<Props> = ({
  title,
  userName,
  description,
  imageUrl,
  category,
  likes,
  hasLiked,
  onLike,
  onUnlike,
  onClose,
}) => {
  const [likeClicked, setLikeClicked] = useState(false);

  // Disable button when clicked
  const handleLike = () => {
    setLikeClicked(true);
    onLike();
  };

  const handleUnlike = () => {
    setLikeClicked(false);
    onUnlike();
  };

  const wrapperClass = classNames({
    [styles["wrapper"]]: true,
  });

  return (
    <div className={wrapperClass}>
      <div className={styles.header}>
        <button className={styles.close} onClick={onClose}>
          <Icon type="exit" size="regular" />
        </button>
        <p className="faded">Sendt inn av {userName || "Anonym"}</p>
      </div>

      {imageUrl && (
        <div className={styles.image}>
          <img src={`${imageUrl}?w=800`} alt={title} />
        </div>
      )}

      <h1>{title || "Innspel uten navn"}</h1>

      <div className={styles.actions}>
        <LikeButton
          likes={likes}
          onClick={hasLiked ? handleUnlike : handleLike}
          liked={likeClicked || hasLiked}
        />
        <Tag>{category || "Ukjent kategori"}</Tag>
      </div>

      <div className={styles.body}>
        <p>{description || "Ingen beskrivelse"}</p>
      </div>

      <div className={styles.footer}>
        <LikeButtonLarge
          liked={likeClicked || hasLiked}
          onClick={hasLiked ? handleUnlike : handleLike}
        />
      </div>
    </div>
  );
};

export default EntryCardLarge;
